import React from "react";
import UsersDailyPerformanceTable from "../../components/Users/UsersDailyPerformance/UsersDailyPerformanceTable";
import UsersPerformanceTable from "../../components/Users/UsersPerformanceTable/UsersPerformanceTable";

const OperatorOverviewList: React.FC<{}> = (props) => {
	return <UsersDailyPerformanceTable />;
};

export default OperatorOverviewList;
